var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 13,
  height: 13,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("rect", {
  x: 7,
  width: 6,
  height: 2,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  transform: "rotate(-45 9.39 4.268)",
  x: 5.768,
  y: 3.268,
  width: 7.243,
  height: 2,
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  x: 11,
  width: 2,
  height: 6,
  rx: 1
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 11h12v1a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1v-1zM2 0h2a1 1 0 1 1 0 2H1V1a1 1 0 0 1 1-1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1 0h1v13H1a1 1 0 0 1-1-1V1a1 1 0 0 1 1-1zm11 8a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1h-1V9a1 1 0 0 1 1-1z"
}))));
export { SvgLinkIcon as ReactComponent };
export default __webpack_public_path__ + "assets/media/link-icon.44dda90a3be5915f196fd57aebf80adc.svg";